import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-anmar-company-profiles',
  templateUrl: './company-profiles.component.html',
})
export class CompanyProfilesComponent implements OnInit {
  readonly locales: Array<'ar' | 'en'> = ['ar', 'en'];
  profiles: any[] = [];
  selected: Record<string, File | null> = { ar: null, en: null };
  loading = false;
  uploading: 'ar' | 'en' | null = null;
  errorMessage = '';
  private readonly baseUrl = `${(environment as any).dashboardApiBase}`.replace(/\/+$/, '');

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  ngOnInit(): void { this.load(); }

  load(): void {
    this.loading = true;
    this.http.get(`${this.baseUrl}/dashboard/company-profiles`).subscribe({
      next: (response: any) => {
        this.profiles = Array.isArray(response?.data) ? response.data : [];
        this.loading = false;
      },
      error: (error) => {
        this.errorMessage = error?.error?.message || 'Unable to load company profiles.';
        this.loading = false;
      },
    });
  }

  onFileSelected(locale: 'ar' | 'en', event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files?.[0] || null;
    if (file && file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      this.selected[locale] = null;
      this.toastr.error('Only PDF files are accepted.');
      return;
    }
    this.selected[locale] = file;
  }

  replace(locale: 'ar' | 'en'): void {
    const file = this.selected[locale];
    if (!file) {
      this.toastr.error('Choose a PDF file first.');
      return;
    }
    this.uploading = locale;
    const form = new FormData();
    form.append('file', file, file.name);
    this.http.post(`${this.baseUrl}/dashboard/company-profiles/${locale}`, form).subscribe({
      next: () => {
        this.uploading = null;
        this.selected[locale] = null;
        this.toastr.success('Company profile updated.');
        this.load();
      },
      error: (error) => {
        this.uploading = null;
        this.toastr.error(error?.error?.message || 'Unable to update company profile.');
      },
    });
  }

  profile(locale: 'ar' | 'en'): any {
    return this.profiles.find((item) => item.locale === locale);
  }
}
